var _rect, _line, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.114,
    y: 2.614,
    width: 15.771,
    height: 18.771,
    rx: 4.188,
    ry: 4.188
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.844,
    y1: 15.894,
    x2: 11.844,
    y2: 7.224
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "15.943 12.758 11.844 16.858 7.734 12.748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.977cc1a63a7bc46f8335c972895d7158.svg";
export { ForwardRef as ReactComponent };